import { SecurityResponseMembershipOptions } from '../../../../../models/enums/SecurityResponseMembershipOptions';
import { IFormCheckboxGroupOptionProps } from '../../../../../styledComponents/UI/Form/FormCheckboxGroup/formCheckboxGroup.models';

export const EDIT_SR_MEMBERSHIP_OPTIONS_MODAL =
  'EDIT_SR_MEMBERSHIP_OPTIONS_MODAL';

export const srMembershipOptionsList: IFormCheckboxGroupOptionProps[] = [
  {
    name: SecurityResponseMembershipOptions.SendWelcomeEmail,
    optionDisabled: true,
  },
  {
    name: SecurityResponseMembershipOptions.EmailOptOut,
  },
];
